import { render, staticRenderFns } from "./NewsTop.vue?vue&type=template&id=b5f3a66e&scoped=true&"
import script from "./NewsTop.vue?vue&type=script&lang=js&"
export * from "./NewsTop.vue?vue&type=script&lang=js&"
import style0 from "./NewsTop.vue?vue&type=style&index=0&id=b5f3a66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f3a66e",
  null
  
)

export default component.exports